/*
  Opens the Accessibly app widget from a button in the theme header.

  The app renders a floating launcher of its own:

    #accessiblyWidgetLandmark
      #accessiblyAppWidgetButton   <- container, hidden by the theme CSS
        #accessiblyAppDialogButton <- the control that actually opens the panel
      #accessiblyAppDialog         <- the panel, a sibling of the container

  Because the panel is a sibling rather than a child, hiding the launcher does not
  affect it, and a programmatic click on the button still opens it.

  The app loads from an external script, so the button may not exist when this file
  runs. The click is delegated from the document and the lookup retries briefly, which
  keeps this working no matter which of the two finishes loading first.
*/

(function () {
  'use strict';

  var TRIGGER_SELECTOR = '[data-accessibly-trigger]';
  var APP_BUTTON_ID = 'accessiblyAppDialogButton';
  var RETRY_COUNT = 20;
  var RETRY_DELAY = 150;

  function openWidget(retriesLeft) {
    var appButton = document.getElementById(APP_BUTTON_ID);

    if (appButton) {
      appButton.click();
      return;
    }

    if (retriesLeft > 0) {
      setTimeout(function () {
        openWidget(retriesLeft - 1);
      }, RETRY_DELAY);
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest ? event.target.closest(TRIGGER_SELECTOR) : null;
    if (!trigger) return;

    event.preventDefault();
    openWidget(RETRY_COUNT);
  });
})();